import { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { useForm } from "react-hook-form";
import { Link, useSearchParams } from "react-router-dom";

import { InfoText } from "../../common/components/info_text";
import Button from "../../common/components/controls/button/styled-button";
import { SectionDivider } from "../../common/components/section_divider";
import { Field } from "../../common/components/controls/field";
import { AuthPage } from "../../common/components/template_page/auth";
import { FormStepCard } from "../../common/components/form_steps";

import { useUser } from "../../common/hooks/User";
import { getUserProfile } from "../../common/apis/private.api";

import { saveUserAuthData } from "../../common/helpers/utilities";
import { saveLocalData } from "../../common/helpers/localData";
import { textChooser } from "../../common/util/textChooser";

import { setUserId } from "../../common/analytics";
import { ForgotPassContainer, FormContainer } from "./styled";
import { ButtonSocial } from "../../common/components/controls/button";

const initialState = {
  pass: false, user: false, loading: false
}

export const Login = () => {
  const { initUserSession } = useUser();
  const { register, handleSubmit } = useForm();

  const [formStatus, setFormStatus] = useState(initialState);
  const [params] = useSearchParams();
  
  const search = params.get('ref')

  useEffect(() => {
    if (!search) return;

    saveLocalData('loginRedirect', search);
  }, [])

  const handleClassicLogin = ({ user, pass }: any) => {
    setFormStatus({ ...initialState, loading: true });

    Auth.signIn(user, pass).then((auth) => {
      saveUserAuthData(auth);
      getUserProfile(user).then((profile) => {

        initUserSession(auth, profile);

        setUserId(profile.email)

      }).catch(() => initUserSession(auth));
    }).catch(() => setFormStatus({ user: true, pass: true, loading: false }));
  }

  return (
    <AuthPage>
      <FormStepCard className="-login" title={textChooser("txt1")} showBackButton={false} >
        <>
          <FormContainer onSubmit={handleSubmit(handleClassicLogin)}>
            <Field
              type="email"
              hasIcon={true}
              hasError={formStatus.user}
              placeholder={textChooser("txt4")}
              label={textChooser("txt30")}
              testId={"user-login-field"}
              maxLength={35}
              minLength={6}
              hooks={{ ...register("user", { required: true }) }}
            />
            <InfoText
              text={textChooser("txt11")}
              type={"danger"}
              hidden={!formStatus.user}
            />
            <Field
              type="password"
              hasIcon={true}
              hasError={formStatus.pass}
              placeholder={textChooser("txt31")}
              label={textChooser("txt5")}
              testId={"pass-login-field"}
              maxLength={35}
              minLength={6}
              hooks={{ ...register("pass", { required: true }) }}
            />
            <InfoText
              text={textChooser("txt12")}
              type={"danger"}
              hidden={!formStatus.pass}
            />

            <Button type="submit" disabled={formStatus.loading}>{textChooser(formStatus.loading ? "txt140" : "txt6")}</Button>

            <SectionDivider />
          </FormContainer>

          <ButtonSocial type="Google" />

          <ButtonSocial type="Facebook" />

          <ForgotPassContainer>
            <Link to="/forgot-password" className="outline">
              {textChooser("txt10")}
            </Link>
          </ForgotPassContainer>

          <ForgotPassContainer>
            <Link className="register" to="/register">
              {textChooser('txt231')} <span>{textChooser('txt233')}</span>
            </Link>
          </ForgotPassContainer>
        </>
      </FormStepCard>
    </AuthPage >
  )
}